export default {};



// WEBPACK FOOTER //
// ./src/store/modules/image/state.js